const getLocation = () => Intl.DateTimeFormat().resolvedOptions().timeZone
export default getLocation
